<template src="./LaboratoryExams.html" />

<script>
import { useStore } from "@/store/store.js"
import mixins from "@/Mixins.js"

export default {
  mixins: [mixins],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      searchedCount: 0,
      dateInitial: "",
      dateFinal: "",
      titlePopup: "",
      customer: [],
      idCustomer: null,
      disabledSearchButton: true,
      popupCustomerDetails: false,
      showWebButtons: true,
      historic: [],
      historicFiltered: [],
      queryString: "",
      queryStringOld: "",
      currentx: 1,
      numPages: 0,
      pagination: false,
      selected: [],
      historicCache: [],
      historicOk: false,
      csvHistoric: {
        cod_exame: "",
        nome_exame: "",
        cod_Tuss: "",
        valor_padrao: "",
        valor_Filoo: "",
        desconto: ""
      },
      historicCsv: [],
      popupDiscount: false,
      adrressLabs: undefined,
      adrressLabsNamePhone: ["", ""],
      coordsMock: { lat: "-20.1737263", lon: "-48.0364479" },
      cepSearch: "&nbsp;",
      addressLab: "",
      cepLab: "",
      latLab: "",
      lonLab: "",
      cepInvalid: false,
      errorStr: "",
      selectedTr: ""
    };
  },
  setup () {
    const store = useStore()

    return {
      getGoogleAddress: (cep) => store.dispatch("getGoogleAddress", cep),
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    cepSearch: function() {
        this.cepInvalid = false;
    },
    popupDiscount: function(newVal) {
        this.cepInvalid = newVal? this.cepInvalid : newVal;
    },
    currentx: function() {
      this.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getExams();
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 600) {
        vm.showWebButtons = false;
      } else {
        vm.showWebButtons = true;
      }
    },
    changeDateInitial() {
      const vm = this;
      if (
        vm.isDate(vm.dateInitial) === true &&
        vm.isDate(vm.dateFinal) === true
      ) {
        vm.disabledSearchButton = false;
      } else {
        vm.disabledSearchButton = true;
      }
    },
    changeDateFinal() {
      const vm = this;
      if (
        vm.isDate(vm.dateInitial) === true &&
        vm.isDate(vm.dateFinal) === true
      ) {
        vm.disabledSearchButton = false;
      } else {
        vm.disabledSearchButton = true;
      }
    },
    searchInclusionDate() {
      const vm = this;

      if (vm.searchedCount >= 1) {
        vm.historic = vm.historicCache;
        vm.$nextTick(function() {
          vm.searchAfterFillArray();
        });
      } else {
        vm.searchAfterFillArray();
      }
    },
    searchAfterFillArray() {
      const vm = this;
      let startDate = new Date(vm.dateInitial);
      let endDate = new Date(vm.dateFinal);
      vm.searchedCount = +1;
      let resultProductData = vm.historic.filter(function(a) {
        let hitDates = new Date(a.usDate);

        return (
          (hitDates >= startDate && hitDates <= endDate) ||
          (hitDates == startDate && hitDates == endDate)
        );
      });

      if (resultProductData.length > 0) {
        vm.historic = resultProductData;
      } else {
        vm.historic = [];
      }
    },

    getExams() {
      const vm = this;
      const bearer = vm.$session.get("bearer");
      const page = vm.currentx - 1;
      const validQuery = vm.queryString
        .split('')
        .map(char => ( char === '%' || char === '&' || char === '+' || char === '^' ? '?' : char ))
        .join('')
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "exams/exames?page=" +
            page +
            "&search=" +
            validQuery +
            "&size=9&sort=id,asc",
          {
            headers: { Authorization: bearer }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.historic = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.historicOk = true;
          }
          if (vm.historic.length === 0) 
            vm.showNotifyWarning(
              `Nenhum resultado encontrado para "${vm.queryString}". Por favor, altere o item pesquisado e tente novamente!`,
              6000
              )
        });
    },
    fillHistoric() {
      const vm = this;
      for (let h in vm.historic) {
        if (
          vm.testNullUndefinedEmpty(vm.historic[h].valueDefault) == false &&
          vm.testNullUndefinedEmpty(vm.historic[h].valueFiloo) == false
        ) {
          let calc =
            (vm.historic[h].valueDefault * 100) / vm.historic[h].valueFiloo;
          let result = 100 - calc;
          vm.historic[h].discount = result.toFixed(2) * -1;
        }
        vm.historic[h].valueDefaultMoney =
          vm.testNullUndefinedEmpty(vm.historic[h].valueDefault) == false
            ? vm.historic[h].valueDefault
            : "-";
        vm.historic[h].valueFilooMoney =
          vm.testNullUndefinedEmpty(vm.historic[h].valueFiloo) == false
            ? vm.historic[h].valueFiloo
            : "-";
      }

      vm.fillHistoricCSV();
    },
    fillHistoricCSV() {
      const vm = this;
      for (let h in vm.historic) {
        vm.historicCsv.push(Object.assign({}, vm.csvHistoric));
        vm.historicCsv[h].exame.codExame = vm.historic[h].codExame;
        vm.historicCsv[h].exame.codTuss = vm.historic[h].codTuss;
        vm.historicCsv[h].exame.name = vm.historic[h].name;
        vm.historicCsv[h].valueDefault = vm.historic[h].valueDefault;
        vm.historicCsv[h].valueFiloo = vm.historic[h].valueFiloo;
        vm.historicCsv[h].desconto = 11;
      }
    },
    handleSelected(tr) {
      const vm = this;
      vm.selectedTr = tr;
      vm.adrressLabsNamePhone = [];
      vm.adrressLabsNamePhone.push(tr.laboratorio.name, tr.laboratorio.phone);
      vm.popupDiscount = true;
      vm.adrressLabs = undefined;
      if(!vm.testNullUndefinedEmpty(vm.latLab) && !vm.testNullUndefinedEmpty(vm.lonLab)) {
          vm.getExamsAddressLab();
      }
    },
    getExamsAddressLab() {
      const vm = this;
      var tr = vm.selectedTr;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "exams/address-laboratorio/" +
            tr.laboratorio.id +
            "/" +
            vm.latLab +
            "/" +
            vm.lonLab,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.adrressLabs = response.data;
            for (let i in vm.adrressLabs) {
                vm.adrressLabs[i]["showMap"] = false;
            }
          }
        });
    },
    googleCoords(tr) {
      return {
        lat: parseFloat(tr.latitude),
        lng: parseFloat(tr.longitude)
      };
    },
    googleMarker(id) {
      return [
        { position: this.googleCoords(id) }
      ]
    },
    changePagination() {
      this.getExams()
    },
    async searchAddress() {
      this.cepInvalid = !this.cepSearch

      if (!this.cepInvalid) {
        const response = await this.getAddressByZipcode(this.cepSearch)
        this.cepInvalid = response && response.address

        if (!this.cepInvalid) {
          const { street, neighborhood, city, state } = response.address

          this.addressLab = `${street}, ${neighborhood} - ${city} / ${state}`
          this.latLab = response.lat
          this.lonLab = response.lng
        } else {
          this.addressLab = ""
        }
      }
    },

    async getGeolocation() {
      if (!("geolocation" in navigator)) {
        this.errorStr = "Geolocalização não está habilitada."
      } else {
        this.gettingLocation = true
        await navigator.geolocation.getCurrentPosition(
          async ({ coords }) => {
            this.$vs.loading()

            if (coords && coords.latitude && coords.longitude) {
              const response = await this.getGoogleAddress({
                lat: coords.latitude,
                lng: coords.longitude,
              })

              if (response) {
                this.addressLab = await response.formatted_address

                this.latLab = await response.geometry.location.lat
                this.lonLab = await response.geometry.location.lng

                this.cepLab = await response.address_components
                  .find((addr) => (addr.types.includes("postal_code")))
                  .short_name
              }
            }
          },
          err => {
            this.gettingLocation = false
            this.errorStr = err.message
          }
        )

        this.$vs.loading.close()
      }
    },

    showMap(i) {
        const vm = this;
        vm.adrressLabs[i].showMap = !vm.adrressLabs[i].showMap;
        vm.adrressLabs.push({});
        vm.adrressLabs.pop();
    },

    isToShow(i) {
        const vm = this;
        return vm.adrressLabs[i].showMap;
    }
  }
};
</script>
<style lang="scss" src="./LaboratoryExams.scss"></style>
